export default __webpack_public_path__ + "static/media/bannerarcade.a04eda2d.png";